<template>
  <!-- 照明策略  zhaoming-->
  <div class="applicationtype">
    <div class="con">
      <div class="search-input-btn" style="width:100%">
        <div class="input-small">
          <span>名称：</span>
          <el-input v-model="searchName" clearable placeholder="请输入名称"></el-input>
        </div>
        <el-button type="primary" plain @click="search_fn" class="search-btn">查询</el-button>
        <el-button type="primary" @click="add_ed(0)" class="search-btn last-el-button">新增</el-button>
      </div>
      <div class="mytable">
        <el-table id="demo" :height="heights" stripe :data="tableData" style="width: 100%" row-key="id"
          v-loading='isMask'>
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" label="序号" width="60" align="center">
          </el-table-column>
          <el-table-column label="策略名称" align="center" prop="a" />
          <el-table-column label="动作状态" align="center" prop="b" width="90" />
          <el-table-column label="时间日期" align="center" prop="c" width="310" />
          <el-table-column label="教室数量" align="center" prop="d" width="90" />
          <el-table-column label="教室名称" align="center" prop="e" width="140" />
          <el-table-column label="创建时间" align="center" prop="f" width="140" />
          <el-table-column label="操作" align="center" width="390">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="detail_status =true;">设备</el-button>
              <el-button type="warning" size="mini">启用</el-button>
              <el-button type="primary" size="mini">绑定</el-button>
              <el-button type="success" size="mini" @click="popupFn('eait')">修改</el-button>
              <el-button type="danger" size="mini" @click="delFun(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 详情 -->
      <el-dialog title="设备详情" v-dialogDrag :visible.sync="detail_status" center>
        <el-table ref="multipleTable" :data="deviceTableData" tooltip-effect="dark" style="width: 100%" max-height="800"
          border>
          <el-table-column width="50" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column label="设备号" width="80">
            <template slot-scope="scope">{{ scope.row.deviceno }}</template>
          </el-table-column>
          <el-table-column prop="devicename" label="设备名称">
          </el-table-column>

        </el-table>
        <template #footer>
          <span class="dialog-footer">
            <el-button type="primary" @click="detail_status = false">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>

      <!-- 新增修改 -->
      <el-dialog :title="textMap[dialogStatus]" :close-on-click-modal='false' v-dialogDrag :visible.sync="dialogVisible"
        center>
        <el-table ref="multipleTable" :data="deviceTableData" tooltip-effect="dark" style="width: 100%" max-height="800"
          border>
          <el-table-column width="70" align="center" label="序号">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column label="设备号" width="80">
            <template slot-scope="scope">{{ scope.row.deviceno }}</template>
          </el-table-column>
          <el-table-column prop="devicename" label="设备名称">
          </el-table-column>

        </el-table>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>

  //   import htmlToPdf from '@/vendor/htmlToPdf';
  import {getAllEnergyType,getAllTypeByGroup,getAppTypeByGroupId,saveEnergyType,deleteEnergyType} from "../../api/energySubType";
  import {findAllAppType,apptypeSave,apptypeDeleteById} from "../../api/application";
  import resourcesStore from '@/cache/resourcesStore.js'
  import elIconBtn from '@/components/module/iconBtns.vue'
  export default {
    components: {elIconBtn},
    data () {
      return {
        tableData1: [],
        isMask: false,//遮罩层
        loading: true,
        deviceTableData: [{
          deviceno: 3,
          devicename: 'A栋101'
        },
        {
          deviceno: 11,
          devicename: 'A栋201'
        },
        {
          deviceno: 13,
          devicename: 'A栋301'
        },
        {
          deviceno: 22,
          devicename: 'A栋302'
        }],

        searchName: "",//搜索名称
        total: 0,
        topLevel: 0,
        detail_status: false,
        Password: '',
        temp: {},
        dialogStatus: '',
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        heights: document.getElementById('app').clientHeight-250,
        tableData: [{
          a: '照明策略',
          b: '开',
          c: '周一  至 周五 8:00',
          d: '3',
          e: '201、202、203',
          f: '2024/6/15/8:50',
        },{
          a: '照明策略',
          b: '关',
          c: '周一  至 周五 18:00',
          d: '3',
          e: '204、205、206',
          f: '2024/6/14/8:50',
        }],

        tableDataCopy: [],
        optionsd: {},
        defaultProps: {
          children: "next",
          label: "name"
        },
        dialogVisible: false,
        rules: {
          name: [
            {required: true,message: '请输入类型名称',trigger: 'blur'}
          ],
        },
        options: [],
        typeOptions: [],
        listData: {
          "Page": 1,
          "Rows": 10
        },

        columns: [
          {
            name: "编码",
            // key: "Code",
            key: "no",
            width: 90,
            al: 'center'
          },{
            name: "类型",
            // key: "Coefficient",
            key: "entityName",
            width: 90,
            al: 'center'
          }
        ],
      };
    },
    computed: {
      getResourcesByName () {
        return resourcesStore.getters.getResourcesByName
      },
    },
    watch: {
      'temp.appType': function(val) {
        // console.log("askdbhk",val);
        if(val==''||!val) {
          this.typeOptions=[]
          return
        }

        getAppTypeByGroupId({'groupId': val}).then(res => {
          // console.log(res);
          if(res.code==200) {
            this.typeOptions=res.data
          }
        })
      },
      dialogVisible: function(val) {
        // console.log(val);
        if(!val) {
          this.temp={}
        }
      },
      searchName (val) {
        if(val=='') {
          this.loading=true
          setTimeout(() => {
            this.loading=false
          },1000);
          this.deviceTableData=this.deviceTableDataCopy
        }
      },
    },
    mounted () {

      //应用类型编码
      getAllTypeByGroup().then(res => {
        //  console.log("res应用类型",res);
        this.options=res.data;
        this.getList();//获取列表数据 
      })

    },
    methods: {
      // 删除
      delFun (i) {
        this.$confirm('是否删除此数据','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableData.splice(i,1)
          this.$message({showClose: true,message: '删除成功',type: 'success'});
        }).catch(() => {
          // ...
        });

      },
      //搜索列表
      search_fn () {
        this.loading=true
        setTimeout(() => {
          this.loading=false
        },1000);
        this.tableData=this.tableDataCopy.filter((item) => item.name.includes(this.searchName));
      },

      //详情
      detail (v) {
        this.temp=v;
        this.detail_status=true;
      },
      // 删除管理员
      delete_fn (v) {
        this.$confirm(`是否删除 ${v.name}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // console.log(v);
          apptypeDeleteById({'no': v.no}).then(res => {
            if(res.code==200) {
              this.$message({showClose: true,message: '删除成功',type: 'success'});
              this.getList();
            } else {
              this.$message.error(`删除失败，${res.message}`);
            }
          })
        }).catch(() => {
          // ...
        });

      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            this.temp.uid=null
            apptypeSave(this.temp).then(data => {
              if(data.code==200) {
                this.getList();
                this.temp={}
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                this.$message.error(`添加失败，${data.message}`);
              }
            })
          } else {
            return false;
          }
        });
      },
      // 添加弹窗
      add_ed (v,l) {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.topLevel=v
        // console.log(v);
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认编辑
      edit_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            // console.log("this.temp",this.temp);
            // this.temp.uid = this.temp.no
            var d={
              "name": this.temp.name,
              "uid": this.temp.no,
            }
            apptypeSave(d).then(data => {
              // console.log(data);
              if(data.code==200) {
                this.getList();
                this.temp={}
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                this.$message.error(`修改失败，${data.message}`);
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },


      //获取列表数据
      getList () {

      },


    }
  };
</script>

<style lang="scss" scoped>
  .applicationtype {
    .con {
      width: 100%;
      height: 100%;
      padding: 12px 20px;
      box-sizing: border-box;
      background-color: #fff;

    }

    /deep/.el-dialog {
      width: 460px !important;

    }

    .mydialog {
      /deep/.el-input {
        width: 240px !important;
      }
    }

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }



    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

  }
</style>